import { mainAdminSplitApi } from 'redux/store/mainSplitApi'
import { type QueryParameters, type QueryResult } from 'types'
import { type RasnFamily, type RasnFamilyDetails, type RasnFamilyGoodsholdersResponse, type RasnFamilyUnitsResponse } from 'types/RasnFamily'

const rasnFamilyApi = mainAdminSplitApi.injectEndpoints({
  endpoints: (builder) => ({
    searchRasnFamilies: builder.query<QueryResult<RasnFamily>, Partial<QueryParameters<RasnFamily>>>({
      query: (parameters) => {
        return {
          url: '/rasn-families',
          params: parameters
        }
      },
      providesTags: ['SearchRasnFamilys']
    }),
    getRasnFamily: builder.query<RasnFamilyDetails, string>({
      query: (rasnFamilyId) => {
        return {
          url: `/rasn-families/${rasnFamilyId}`
        }
      },
      providesTags: (result, error, rasnFamilyId) => [{ type: 'RasnFamilyDetails', id: rasnFamilyId }]
    }),
    getRasnFamilyUnits: builder.query<RasnFamilyUnitsResponse, string>({
      query: (rasnFamilyId) => {
        return {
          url: `/rasn-families/${rasnFamilyId}/units`
        }
      },
      providesTags: (result, error, rasnFamilyId) => [{ type: 'RasnFamilyUnits', id: rasnFamilyId }]
    }),
    getRasnFamilyGoodsholders: builder.query<RasnFamilyGoodsholdersResponse, string>({
      query: (rasnFamilyId) => {
        return {
          url: `/rasn-families/${rasnFamilyId}/goodsholders`
        }
      },
      providesTags: (result, error, rasnFamilyId) => [{ type: 'RasnFamilyGoodsholders', id: rasnFamilyId }]
    }),
    performRasnFamilyAction: builder.mutation<void, { rasnFamilyId: string, action: string }>({
      query: ({ rasnFamilyId, action }) => {
        return {
          url: `/rasn-families/${rasnFamilyId}`,
          method: 'PATCH',
          params: {
            action
          }
        }
      },
      invalidatesTags: (result, error, { rasnFamilyId }) => [
        { type: 'RasnFamilyDetails', id: rasnFamilyId },
        { type: 'RasnFamilyGoodsholders', id: rasnFamilyId },
        'SearchRasnFamilys',
        'SearchRasns'
      ]
    })
  })
})

export const {
  useSearchRasnFamiliesQuery,
  useGetRasnFamilyQuery,
  useGetRasnFamilyUnitsQuery,
  useGetRasnFamilyGoodsholdersQuery,
  usePerformRasnFamilyActionMutation
} = rasnFamilyApi
